import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","justify-content":"flex-end"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 导出 ")
const _hoisted_3 = { style: {"font-size":"0.6rem"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 闭环 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 暂闭环 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 持续跟进 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 无法闭环 ")
const _hoisted_8 = { style: {"display":"flex","justify-content":"flex-end"} }

import stubs from '@/init';
import { computed, reactive, ref } from 'vue';

import {
  RmRiskWarnSearchParamVO,
  RmRiskWarnSearchResultVO,
  RmRiskWarnUpdateStatusParamVO,
  RmRiskWarnStatusEnum,
} from './vo';
import {
  CockpitYearSubsidiaryVO,
  CockpitYearVO,
} from '../../../config/views/home/vo';
import RmRiskWarnController from './controller/RmRiskWarn.Controller';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const controller: RmRiskWarnController =
  stubs.injector.get(RmRiskWarnController);
const state = reactive({
  form: {
    page: 1,
    size: 10,
    year: null,
    regionId: null,
    companyId: null,
    type: null,
    status: null,
  } as RmRiskWarnSearchParamVO,
  genForm: {} as RmRiskWarnUpdateStatusParamVO,
  data: [] as Array<RmRiskWarnSearchResultVO>,
  years: [] as Array<CockpitYearVO>,
  dialogFormVisible: false,
  type: '',
  total: 0,
});

const regions = computed(() => {
  return (
    state.years.find((item) => item.year === state.form.year)?.region || []
  ).map((it: any) => ({ label: it.name, value: it.id }));
});

const subsidiary = computed(() =>
  (state.years.find((item) => item.year === state.form.year)?.subsidiary || [])
    .filter((sub) => {
      return !state.form.regionId || state.form.regionId.includes(sub.regionId);
    })
    .map((it: CockpitYearSubsidiaryVO) => ({ label: it.name, value: it.id }))
);

const search = async (page?: number) => {
  state.form.page = page ? page : state.form.page;
  const res = await controller.search(state.form);
  state.data = res.result;
  state.total = res.totalElements || 0;
};

const updateStatus = async (id: string, status: RmRiskWarnStatusEnum) => {
  const form = { id: id, status: status } as RmRiskWarnUpdateStatusParamVO;
  await controller.updateStatus(form);
  search();
};

const reset = () => {
  state.form = {
    page: 1,
    size: 10,
  } as any;
  search(1);
};

const init = async () => {
  state.years = await controller.year();
  search(1);
};

const download = () => {
  controller.download(state.form);
};

const colors = ['#00fa99', '#37fdff', '#fac800', '#ff6c00', '#f03200', '#fff'];
colors.reverse();
const CellStyle = ({ row, columnIndex }: { row: any; columnIndex: number }) => {
  if (columnIndex === 6) {
    let index = 0;
    try {
      index = row.riskLevel || 0;
    } catch (e) {
      console.log(e);
    }
    return {
      backgroundColor: colors[index],
    };
  }
  return {};
};

init();

return (_ctx: any,_cache: any) => {
  const _component_simple_select = _resolveComponent("simple-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_mas_form_main = _resolveComponent("mas-form-main")!
  const _component_wapper = _resolveComponent("wapper")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_Top = _resolveComponent("Top")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Bottom = _resolveComponent("Bottom")!
  const _component_simple_table_column = _resolveComponent("simple-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_wapper, null, {
      default: _withCtx(() => [
        _createVNode(_component_mas_form_main, {
          inline: true,
          form: _unref(state).form,
          defaultFormFooterButton: ['confirm', 'reset'],
          defaultFormFooterConfirmText: "搜索",
          "label-width": "120px",
          onConfim: _cache[5] || (_cache[5] = ($event: any) => (search())),
          onReset: reset
        }, {
          content: _withCtx((slotProps) => [
            _createVNode(_component_el_form_item, { label: "年份" }, {
              default: _withCtx(() => [
                _createVNode(_component_simple_select, {
                  style: {"width":"240px"},
                  clearable: "",
                  options: 
                _unref(state).years.map((it) => ({ label: it.year, value: it.year }))
              ,
                  modelValue: slotProps.content.year,
                  "onUpdate:modelValue": ($event: any) => ((slotProps.content.year) = $event),
                  onChange: _cache[0] || (_cache[0] = 
                () => {
                  _unref(state).form.companyId = '';
                  _unref(state).selectedRegionId = '';
                }
              )
                }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_form_item, { label: "大区" }, {
              default: _withCtx(() => [
                _createVNode(_component_simple_select, {
                  style: {"width":"240px"},
                  options: _unref(regions),
                  clearable: "",
                  modelValue: _unref(state).form.regionId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).form.regionId) = $event)),
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_unref(state).form.companyId = ''))
                }, null, 8, ["options", "modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "分公司" }, {
              default: _withCtx(() => [
                _createVNode(_component_simple_select, {
                  style: {"width":"240px"},
                  clearable: "",
                  options: _unref(subsidiary),
                  modelValue: slotProps.content.companyId,
                  "onUpdate:modelValue": ($event: any) => ((slotProps.content.companyId) = $event)
                }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_form_item, { label: "类型" }, {
              default: _withCtx(() => [
                _createVNode(_component_simple_select, {
                  style: {"width":"240px"},
                  clearable: "",
                  options: _ctx.pocket('rmRiskWarnType'),
                  modelValue: _unref(state).form.type,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(state).form.type) = $event))
                }, null, 8, ["options", "modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_simple_select, {
                  style: {"width":"240px"},
                  clearable: "",
                  options: _ctx.pocket('rmRiskWarnStatus'),
                  modelValue: _unref(state).form.status,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(state).form.status) = $event))
                }, null, 8, ["options", "modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["form"])
      ]),
      _: 1
    }),
    _createVNode(_component_wapper, null, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: download
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_el_table, {
            class: "common-table",
            data: _unref(state).data,
            "cell-style": CellStyle,
            border: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "year",
                label: "年",
                "min-width": "100"
              }),
              _createVNode(_component_el_table_column, {
                prop: "regionName",
                label: "大区名称",
                "min-width": "100"
              }),
              _createVNode(_component_el_table_column, {
                prop: "companyName",
                label: "公司名称",
                "min-width": "100"
              }),
              _createVNode(_component_el_table_column, {
                prop: "warnModuleName",
                label: "预警模块",
                "min-width": "100"
              }),
              _createVNode(_component_el_table_column, {
                prop: "riskMetricsName",
                label: "预警指标",
                "min-width": "140"
              }),
              _createVNode(_component_el_table_column, {
                prop: "riskValue",
                label: "值",
                "min-width": "100"
              }),
              _createVNode(_component_el_table_column, {
                prop: "riskLevel",
                label: "定级",
                "min-width": "50"
              }),
              _createVNode(_component_el_table_column, {
                prop: "compareRiskLevel",
                label: "趋势",
                "min-width": "100"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("span", _hoisted_3, [
                    (row.trendLevel < 0)
                      ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Top, { style: {"color":"#f03200"} })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (row.trendLevel > 0)
                      ? (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Bottom, { style: {"color":"#3dd9d9"} })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_simple_table_column, {
                prop: "type",
                pocketName: "rmRiskWarnType",
                label: "类型",
                "min-width": "100"
              }),
              _createVNode(_component_simple_table_column, {
                prop: "updateTime",
                label: "最后修改时间",
                "min-width": "160"
              }),
              _createVNode(_component_simple_table_column, {
                prop: "status",
                label: "状态",
                "min-width": "100",
                pocketName: "rmRiskWarnStatus"
              }),
              _createVNode(_component_el_table_column, {
                prop: "status",
                label: "操作",
                "min-width": "300"
              }, {
                default: _withCtx(({ row }) => [
                  (row.status !== _unref(RmRiskWarnStatusEnum).CLOSED)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "text",
                        onClick: ($event: any) => (updateStatus(row.id, _unref(RmRiskWarnStatusEnum).CLOSED))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (row.status !== _unref(RmRiskWarnStatusEnum).TEMP)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        type: "text",
                        onClick: ($event: any) => (updateStatus(row.id, _unref(RmRiskWarnStatusEnum).TEMP))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (row.status !== _unref(RmRiskWarnStatusEnum).FOLLOW)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 2,
                        type: "text",
                        onClick: ($event: any) => (updateStatus(row.id, _unref(RmRiskWarnStatusEnum).FOLLOW))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (
                  row.status !== _unref(RmRiskWarnStatusEnum).CLOSED &&
                  row.type !== _unref(RmRiskWarnStatusEnum).UNABLE
                )
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 3,
                        type: "text",
                        onClick: ($event: any) => (updateStatus(row.id, _unref(RmRiskWarnStatusEnum).CLOSED))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_el_pagination, {
              total: _unref(state).total,
              "current-page": _unref(state).form.page,
              "page-size": _unref(state).form.size,
              onCurrentChange: search,
              layout: "total, prev, pager, next, jumper"
            }, null, 8, ["total", "current-page", "page-size"])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})